class ProductAccordion extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.activeIndex = null;
    this.sizeChartTrigger = null;
    this.controller = new AbortController();
    this.formatContent = false;
  }

  connectedCallback() {
    this.sizeChartTrigger = this.querySelector('[data-size-chart-trigger]');
    this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
    this.formatContent = this.getAttribute('data-format-content') === 'true';
    const triggerMode = this.getAttribute('data-trigger') || 'click';

    if (this.formatContent) {
      this.applyContentFormatting();
    }

    this.items.forEach((item, index) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      if (trigger && content) {
        if (triggerMode === 'hover') {
          item.addEventListener('mouseenter', () => this.open(index), {
            signal: this.controller.signal,
          });
          item.addEventListener('mouseleave', () => this.close(index), {
            signal: this.controller.signal,
          });
        } else {
          trigger.addEventListener('click', () => this.toggle(index), {
            signal: this.controller.signal,
          });
        }
      }
    });

    if (this.sizeChartTrigger) {
      this.sizeChartTrigger.addEventListener(
        'click',
        () => this.toggleSizeChart(),
        { signal: this.controller.signal }
      );
    }

    this.openFromHash();
  }

  applyContentFormatting() {
    this.querySelectorAll('[data-accordion-content] .rte').forEach((rte) => {
      const blocks = rte.querySelectorAll('p, li');
      const elements = blocks.length > 0 ? [...blocks] : [rte];

      elements.forEach((el) => {
        let html = el.innerHTML;

        // **text** → bold + uppercase
        if (html.includes('**')) {
          html = html.replace(
            /\*\*([^*]+)\*\*/g,
            '<span class="font-bold">$1</span>'
          );
          el.innerHTML = html;
        }

        // #text# → italic
        if (html.includes('#')) {
          html = html.replace(/#([^#]+)#/g, '<span class="italic">$1</span>');
          el.innerHTML = html;
        }

        // Lines starting with - → remove dash, make uppercase
        const stripped = el.innerHTML.replace(
          /(^|<br\s*\/?>)\s*[-–]\s*/gi,
          '$1'
        );
        if (stripped !== el.innerHTML) {
          el.innerHTML = stripped;
        }
      });
    });
  }

  openFromHash() {
    const hash = window.location.hash.slice(1);
    if (!hash) return;

    const targetIndex = this.items.findIndex((item) => item.id === hash);
    if (targetIndex === -1) return;

    this.toggle(targetIndex);
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  toggleSizeChart() {
    document.dispatchEvent(new CustomEvent('size-chart-toggle:open'));
  }

  open(index) {
    const item = this.items[index];
    const content = item.querySelector('[data-accordion-content]');
    const icon = item.querySelector('[data-accordion-icon]');

    this.items.forEach((otherItem, otherIndex) => {
      if (otherIndex !== index) {
        const otherContent = otherItem.querySelector(
          '[data-accordion-content]'
        );
        const otherIcon = otherItem.querySelector('[data-accordion-icon]');
        if (otherContent) otherContent.style.maxHeight = '0';
        if (otherIcon) otherIcon.classList.remove('rotate-90');
      }
    });

    if (content) content.style.maxHeight = content.scrollHeight + 'px';
    icon?.classList.add('rotate-90');
    this.activeIndex = index;
  }

  close(index) {
    const item = this.items[index];
    const content = item.querySelector('[data-accordion-content]');
    const icon = item.querySelector('[data-accordion-icon]');
    if (content) content.style.maxHeight = '0';
    icon?.classList.remove('rotate-90');
    if (this.activeIndex === index) this.activeIndex = null;
  }

  toggle(index) {
    const item = this.items[index];
    const content = item.querySelector('[data-accordion-content]');
    const icon = item.querySelector('[data-accordion-icon]');
    const isOpen = this.activeIndex === index;

    // Close all items first
    this.items.forEach((otherItem, otherIndex) => {
      if (otherIndex !== index) {
        const otherContent = otherItem.querySelector(
          '[data-accordion-content]'
        );
        const otherIcon = otherItem.querySelector('[data-accordion-icon]');

        if (otherContent) {
          otherContent.style.maxHeight = '0';
        }
        if (otherIcon) {
          otherIcon.classList.remove('rotate-90');
        }
      }
    });

    // Toggle current item
    if (isOpen) {
      content.style.maxHeight = '0';
      icon?.classList.remove('rotate-90');
      this.activeIndex = null;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      icon?.classList.add('rotate-90');
      this.activeIndex = index;
    }
  }
}

if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion);
}
